import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --ingrid-between-row-padding: calc(30rem / var(--default-rem-px-count));
      --ingrid-between-column-padding: calc(
        24rem / var(--default-rem-px-count)
      );
      --ingrid-image-wrapper-width: calc(240rem / var(--default-rem-px-count));
    }

    .ingrid-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    h2 {
      grid-column: 2 / 6;
      grid-row: 2;
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    h3 {
      padding-top: calc(12rem / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .cta-wrapper {
      grid-column: 6 / 8;
      grid-row: 2;
      place-self: start end;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
      display: flex;
      overflow-x: auto;
    }

    .images > * {
      padding: 0 calc(6rem / var(--default-rem-px-count));
      padding-bottom: calc(12rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      width: var(--ingrid-image-wrapper-width);
    }

    .image p {
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .image-cta {
      padding-top: calc(18rem / var(--default-rem-px-count));
    }

    .image > img {
      width: 100%;
    }

    @media (min-width: 600px) {
      .ingrid-layout {
        grid-template-areas:
          var(--empty-row)
          var(--text-header-with-cta)
          var(--empty-row)
          var(--images-row-with-gutter)
          var(--block-line-break);
      }

      h2 {
        grid-area: header;
      }

      .description {
        grid-area: description;
        padding-bottom: calc(80rem / var(--default-rem-px-count));
      }

      .cta-wrapper {
        grid-area: cta;
        place-self: normal right;
      }

      .images {
        grid-column: 2 / 14;
      }

      .image-wrapper {
        width: var(--ingrid-image-wrapper-width);
        max-width: 30%;
      }
    }

    @media (min-width: 800px) {
      :host {
        --ingrid-image-wrapper-width: calc(
          300rem / var(--default-rem-px-count)
        );
      }

      .images {
        grid-column: 3 / 13;
        gap: calc(40rem / var(--default-rem-px-count));
        justify-content: center;
        overflow-x: initial;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --ingrid-between-row-padding: calc(40rem / var(--default-rem-px-count));
        --ingrid-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
        --ingrid-image-wrapper-width: calc(
          350rem / var(--default-rem-px-count)
        );
      }
    }
  `,
];
